import type { ConfirmationStatus } from "../../../services/whatsapp/whatsappService";

const STATUS_CONFIG: Record<ConfirmationStatus, { bg: string; text: string; dot: string; label: string }> = {
  pending: { bg: "bg-gray-50", text: "text-gray-600", dot: "bg-gray-400", label: "Pendiente" },
  awaiting_response: { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-400", label: "Esperando" },
  confirmed: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-400", label: "Confirmado" },
  rejected: { bg: "bg-red-50", text: "text-red-700", dot: "bg-red-400", label: "Rechazado" },
  expired: { bg: "bg-gray-50", text: "text-gray-500", dot: "bg-gray-400", label: "Expirado" },
  canceled: { bg: "bg-gray-50", text: "text-gray-500", dot: "bg-gray-400", label: "Cancelado" },
  send_failed: { bg: "bg-red-50", text: "text-red-700", dot: "bg-red-500", label: "Error de envio" },
};

interface StatusBadgeProps {
  status: ConfirmationStatus;
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10px] font-semibold px-2 py-0.5 rounded-full ${config.bg} ${config.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
      {config.label}
    </span>
  );
};

export default StatusBadge;
